module.exports = __webpack_public_path__ + "templates.checkout-object-detail-1bde216a.html";